<template>
    <div>
        <div class="pb-3">
            <div class="d-flex align-items-center border-bottom">
                Manufacturer
            </div>
            <div class="custom-control custom-checkbox pr-3" v-for="manufacturer in searchOptions.manufacturers" v-bind:value="manufacturer.id" v-bind:key="manufacturer.id" v-show="manufacturer.enabled || manufacturer.checked">
                <input type="checkbox" name="mfr" :id="mfrLabel(manufacturer.id)" :value="manufacturer.id" class="custom-control-input" v-model="searchFilters.manufacturers" v-on:change.prevent="fullSearch()">
                <label :for="mfrLabel(manufacturer.id)" class="custom-control-label">{{manufacturer.name}}</label>
            </div>
        </div>
        <div class="pb-3" v-show="searchOptions.currentTerm != ''">
            <div class="d-flex align-items-center border-bottom">
                Current Search Term
            </div>
            <div class="custom-control custom-checkbox current-term" v-on:click.prevent="clearTerm()">
                <span>{{searchOptions.currentTerm}} [<a href="#">X</a>]</span>
            </div>
        </div>
        <form class="search-form input-group pb-3" v-on:submit.prevent="fullSearch()">
            <input class="form-control search-input" placeholder="Filter by Part Number / Description" aria-label="..." type="text" v-model="searchFilters.term" />
            <button class="btn btn-outline-dark btn-search" v-show="!loading" type="submit" v-bind:disabled="searchFilters.term == ''" v-on:click.prevent="fullSearch()"><i class="fa fa-search"></i></button>
            <a class="btn btn-outline-dark btn-search" v-show="loading" disabled><img style="max-height:24px;" src="@/assets/images/placeholders/loading.gif" /></a>
        </form>
    </div>
    <div>
        <div v-for="item in searchResults" v-bind:key="item">
            <ReferenceSearchItem :searchItem="item"></ReferenceSearchItem>
        </div>
        <div v-show="searchResults.length == 0">
            No results found
        </div>
        <Pager v-if="pages.showPaging" :page="pages.currentPage" :maxPage="pages.maxPage" @paged="fullSearch"></Pager>
    </div>
</template>
<script>
    import { mapGetters, mapState } from 'vuex'
    import referenceApiClient from '@/services/apiServices/referenceApiClient.js'
    import accountApiClient from '@/services/apiServices/accountApiClient.js'
    import ReferenceSearchItem from '@/components/reference/reference-search-item.vue'
    import Pager from '@/components/search/pager.vue'

    export default {
        name: 'ReferenceSearchPanel',
        components: {
            ReferenceSearchItem,
            Pager
        },
        data() {
            return {
                loading: false,
                searchFilters: {
                    manufacturers: [],
                    term: ""
                },
                searchResults: [],
                searchOptions: {
                    manufacturers: [],
                    currentTerm: ""
                },
                pages: {}
            }
        },
        computed: {
            ...mapGetters('oidcStore', [
                'oidcIsAuthenticated'
            ]),
            ...mapState({
                instance: state => state.instance
            })
        },
        methods: {
            mfrLabel(id) {
                return 'mfr-' + id;
            },
            fullSearch: async function (page) {
                await this.$router.isReady();
                if (!this.loading) {
                    var redirectUrl = null;
                    var mfrkey = '';
                    var srckey = '';
                    var pkey = '';
                    var manufacturers = this.searchFilters.manufacturers;
                    if (manufacturers && manufacturers != null && manufacturers.length > 0) {
                        mfrkey = `mfr/${manufacturers.join(',')}/`;
                    }
                    var searchTerm = this.searchFilters.term;
                    if (searchTerm && searchTerm != null && searchTerm != "") {
                        searchTerm = searchTerm.replace('#', '');
                        srckey = `src/${encodeURIComponent(searchTerm)}/`;
                    }
                    if (page == null || page == "" || page == 0) {
                        page = 1;
                    }
                    if (page && (page > 1 || mfrkey != '' || srckey != '')) {
                        pkey = `p/${page}/`;
                    }
                    redirectUrl = `/${this.instance}/reference/${mfrkey}${srckey}${pkey}`;
                    if (this.$route.path != redirectUrl) {
                        this.loading = true;
                        this.$router.push(redirectUrl);
                    }
                }
            },
            search: async function (page) {
                await this.$router.isReady();
                if (!this.loading) {
                    if (!page)
                        page = 1;
                    this.loading = true;
                    this.$store.commit('SET_REFERENCE_VALUES', { selectedMfrIds: this.searchFilters.manufacturers, searchText: this.searchFilters.term, page: page });
                    this.$store.dispatch('refreshProfile');
              }
            },
            clearTerm: async function () {
                this.searchFilters.term = "";
                this.fullSearch()
            },
            GetProfile: async function () {
                await accountApiClient.GetProfileModel().then(response => {
                    if (response.data) {
                        this.userData = response.data;
                    } else {
                        this.$store.commit('SET_GLOBAL_ERROR', 'Profile Content Unavailable');
                    }
                }).catch(() => {
                    this.$store.commit('SET_GLOBAL_ERROR', 'Profile Content Connection Failed');
                });
            }
        },
        beforeUnmount() {
            this.unsubreferencesearchpanel();
        },
        mounted: async function () {
            this.search();
            //subscribes to search mutations
            this.unsubreferencesearchpanel = this.$store.subscribe((mutation) => {
                switch (mutation.type) {
                    case "SET_REFERENCE_VALUES":
                        //Set values for decendent elements
                        this.searchFilters.manufacturers = mutation.payload.selectedMfrIds;
                        this.searchFilters.term = mutation.payload.searchText;
                        this.searchOptions.currentTerm = mutation.payload.searchText;
                        referenceApiClient.GetSearch(this.searchFilters.manufacturers, this.searchFilters.term, mutation.payload.page).then(response => {
                            this.searchResults = response.data.referenceDesigns;

                            if (this.$parent.currentPanel == 'reference') {
                                for (var i = 0; i < this.searchResults.length; i++) {
                                    this.$store.dispatch('gtmReferenceInfluence', { mfrName: this.searchResults[i].manufacturer, mfrPN: this.searchResults[i].partNumber });
                                }
                            }

                            this.searchOptions.manufacturers = response.data.manufacturerFilters;
                            this.pages = response.data.pages;
                            this.loading = false;
                            this.$store.commit('SEARCH_COMPLETE');
                        }).catch(() => {
                            this.loading = false;
                            this.$store.commit('SET_GLOBAL_ERROR', 'Search Api Temporarily Unavailable');
                        });
                }
            }
            );
            await this.$router.isReady();
            if (this.oidcIsAuthenticated)
                await this.GetProfile();
        }
    }
</script>
<style scoped>
    .border-bottom {
        border-bottom: 1px solid #dee2e6 !important;
    }

    .current-term {
        border: 1px solid black;
        box-shadow: 2px 2px;
        display: inline-block;
        padding: 0em .5em;
    }

    .current-term span:hover {
        text-decoration-line: underline;
    }
</style>
